import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_CLEAR_ITEMS,
} from "../constants/cartConstants";

/**
 * item = {
 *   product,
 *   name,
 *   qty,
 *   price,
 *   image?,
 *   selectedOptions?
 * }
 */
export const addToCart = (item) => (dispatch, getState) => {
  dispatch({
    type: CART_ADD_ITEM,
    payload: item,
  });

  localStorage.setItem(
    "cartItems",
    JSON.stringify(getState().cart.cartItems),
  );
};

export const removeFromCart = (id) => (dispatch, getState) => {
  dispatch({
    type: CART_REMOVE_ITEM,
    payload: id,
  });

  localStorage.setItem(
    "cartItems",
    JSON.stringify(getState().cart.cartItems),
  );
};

export const clearCart = () => (dispatch) => {
  dispatch({ type: CART_CLEAR_ITEMS });
  localStorage.removeItem("cartItems");
};
